import { Box } from "@mui/material";
import cn from "classnames";
import { observer } from "mobx-react";
import _get from "lodash/get";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useLocale } from "src/providers/LocaleProvider";
import useStores from "src/hooks/useStores";
import { FriendTypeEnum, IGame } from "src/store/models";
import useChangeTheme from "src/hooks/useChangeTheme";
import paths from "src/consts/paths";
import { useModal } from "src/pages/landing/utils/context";
import openCreateModal from "src/pages/lobby/assets/openCreateModal.svg";
import filterIcon from "src/pages/lobby/assets/filter.svg";
import friendsIcon from "src/assets/icons/UsersThree.svg";

import { useStyles } from "../styles";

import { useStyles as useLocalStyles } from "./styles";
import MobileFriends from "../../../../Friends/mobileFriends";
import { errorService } from "../../../../../../../service/services";
import GameAndInviteFilter, { GameInviteFilters } from "../../../../GameFilter";
import CreateGameModal from "../../../../CreateGameMobile";

interface ICreateBlock {
    isWaitingForGameBlock?: boolean | IGame | undefined;
    isMobileNewGame?: boolean;
    myGameCount: number;
    createBtnDisabled: boolean;
    filters?: GameInviteFilters;
    onApplyFilter?: (filters: GameInviteFilters) => void;
    onResetFilter?: () => void;
}

const CreateGameMobile = ({
    myGameCount,
    createBtnDisabled,
    filters,
    onApplyFilter,
    onResetFilter
}: ICreateBlock) => {
    const { lobbyStore, authStore, friendsStore } = useStores();
    //@ts-ignore
    const isAuthorized = authStore.isAuthorized;
    const bonus = authStore?.currentUser?.balance.bonus;
    const play = authStore?.currentUser?.balance.play;
    const free = authStore?.currentUser?.balance.coins;
    const { openModal } = useModal();
    //@ts-ignore
    const classes = useStyles();
    const localClasses = useLocalStyles();
    const [rounds, setRounds] = useState(1);
    const history = useHistory();
    const {
        lobby: {
            createGame: {
                buttons: { create },
            },
            table: { filterColumn },
        },
        profile: {
            friends: { title },
        },
    } = useLocale();

    const appearanceTheme = useChangeTheme();
    const mobileNewGameHandler = lobbyStore.mobileNewGameHandler;

    const isFreePlay = document.location.href.indexOf("lobby-free-play") > 0;
    const onRoundChange = (value) => setRounds(value);
    const [hasFriendRequests, setHasFriendRequests] = useState(false);
    const [isFriendsOpen, setIsFriendsOpen] = useState(false);

    //Фильтр
    const [filterOpen, setFilterOpen] = useState(false);

    const handleApplyFilter = (newFilters: GameInviteFilters) => {
        setFilterOpen(false);
        if (onApplyFilter) {
            onApplyFilter(newFilters);
        }
    };

    const handleFilterReset = () => {
        if (onResetFilter) {
            onResetFilter();
        }
    };
    //

    //Создать игру
    const [createModalOpen, setCreateModalOpen] = useState(false);

    const handleOpenCreateModal = () => setCreateModalOpen(true);
    const handleCloseCreateModal = () => setCreateModalOpen(false);

    const handleCreateGame = (params) => {
        setCreateModalOpen(false);
    };
    //


    useEffect(() => {
        const checkIncomingRequests = () => {
            if (authStore.isAuthorized && friendsStore) {
                const hasIncoming = friendsStore.friends.some(
                    friend => friend.type === FriendTypeEnum.incoming
                );
                setHasFriendRequests(hasIncoming);
            } else {
                setHasFriendRequests(false);
            }
        };

        if (authStore.isAuthorized && friendsStore) {
            if (friendsStore.friends.length === 0) {
                friendsStore.getFriends();
            }
            checkIncomingRequests();
        }
    }, [authStore.isAuthorized]);


    return (
        <Box className={classes.gameOrFriendscontainer}>

            <Box
                className={cn(
                    classes.gameOrFriendsContainerBox,
                    localClasses.wrapper,
                    appearanceTheme,
                    {}
                )}
            >
                <div className={classes.configWrapper}>
                    {!isFreePlay && (
                        <Box
                            component="div"
                            className={cn(classes.startLobbyUserButtons)}
                        >
                            <div
                                className={cn(classes.mobileGameBlocks)}
                                onClick={() => setFilterOpen(true)}
                            >
                                <img
                                    className={cn(
                                        classes.mobileGameBlocks,
                                        "icon"
                                    )}
                                    src={filterIcon}
                                />
                                <p
                                    className={cn(
                                        classes.mobileGameBlocks,
                                        "text"
                                    )}
                                >
                                    {filterColumn("Filter")}
                                </p>
                            </div>
                        </Box>
                    )}
                    <Box
                        component="div"
                        className={cn(classes.buttonWrapper)}
                        onClick={async () => {
                            if (createBtnDisabled) return;
                            if (!isAuthorized) return openModal("register");

                            if (
                                isAuthorized &&
                                (
                                    (!play && !isFreePlay && !bonus) ||
                                    (isFreePlay && !free)
                                )
                            ) {
                                errorService.sendError("Недостаточно средств для создания игры");
                                setTimeout(() => {
                                    history.push(paths.cashbox);
                                }, 1200);
                                return;
                            }
                            lobbyStore.setSelectedFriend(null);
                            handleOpenCreateModal();
                        }}
                    >
                        <img
                            className={cn(classes.openCreateIcon, {
                                createBtnDisabled: createBtnDisabled,
                            })}
                            src={openCreateModal}
                            alt="open"
                            loading="lazy"
                        />
                        {createBtnDisabled && (
                            <p
                                className={cn(
                                    classes.mobileGameBlocks,
                                    "middleText",
                                    {
                                        createBtnDisabled: createBtnDisabled,
                                    }
                                )}
                            >
                                Game limit
                            </p>
                        )}
                    </Box>
                    {!isFreePlay && <Box
                        component="div"
                        className={cn(classes.startLobbyUserButtons, {
                            disabled: !authStore.isAuthorized,
                            'active-friends': isFriendsOpen
                        })}
                    >
                        <div
                            className={cn(classes.mobileGameBlocks, {
                                'active-friends': isFriendsOpen
                            })}
                            onClick={() => {
                                if (authStore.isAuthorized) {
                                    setIsFriendsOpen(prev => !prev);
                                }
                            }}
                        >
                            <div className={classes.iconWrapper}>
                                <img
                                    className={cn(classes.mobileGameBlocks, "icon", {
                                        'active-friends': isFriendsOpen
                                    })}
                                    src={friendsIcon}
                                />
                                {hasFriendRequests && <div className={classes.friendRequestIndicator}></div>}
                            </div>
                            <p className={cn(classes.mobileGameBlocks, "text", {
                                'active-friends': isFriendsOpen
                            })}>
                                {title("Frienemies")}
                            </p>
                        </div>
                    </Box>}
                    {isFriendsOpen && (
                        <MobileFriends onClose={() => setIsFriendsOpen(false)} />
                    )}
                    <GameAndInviteFilter
                        open={filterOpen}
                        onClose={() => setFilterOpen(false)}
                        filters={filters || {
                            bet: {},
                            time: {},
                            type: {},
                            gameMode: {},
                            matches: {},
                            showGames: true,
                            showInvites: true
                        }}
                        onApply={handleApplyFilter}
                        onReset={handleFilterReset}
                    />
                    <CreateGameModal
                        open={createModalOpen}
                        onClose={() => setCreateModalOpen(false)}
                    />

                </div>
            </Box>
        </Box>
    );
};

export default observer(CreateGameMobile);
